// extracted by mini-css-extract-plugin
module.exports = {"feedAdBanner":"FeedAdBanner_feedAdBanner__2eUlr","advertisement":"FeedAdBanner_advertisement__3F2ju"};